<template lang="html">
  <div class="teaser-tile-media">
    <div class="teaser-tile-media__wrapper">
      <Media
        :path="resource.columns.mediaPath || resource.columns.mediaVideo"
        :autoplay="true"
        :controls="false"
        :pausable="false"
      />
    </div>
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Media from 'beisheim/components/elements/media'

export default {
  components: {
    Media
  },
  mixins: [ editable ]
}
</script>

<style lang="scss">
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/breakpoints';
  @import 'beisheim/scss/font';

  $component: '.teaser-tile-media';

  #{$component} {
    position: relative;
    width: 100vw;
    height: 0;
    padding-top: 100%;

    @include from(3) {
      width: 100vw;
      padding-top: 75%;
    }

    @include from(4) {
      width: 50vw;
      padding-top: 50%;
      max-height: $max-width * 0.5;
      max-width: $max-width * 0.5;
    }

    &__wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;

      .media {
        transition: transform 400ms cubic-bezier(.24,0,.47,1);

        &:hover {
          transform: scaleX(1.1) scaleY(1.1);
        }
      }
    }
  }
</style>
